import { Component, OnInit, Input, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

import * as moment from 'moment';


@Component({

    selector: 'aFormTime,[aFormTime]',
    templateUrl: './aFormTime.component.html',
    styleUrls: ['./aFormTime.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormTimeComponent, multi: true },
    ]
})
export class AFormTimeComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    value;
    date;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        
        this._onChange = fn;
    }
    onChangeDate(value: any) {
        if(value == ''){
            this.value=null;
            this._onChange(null);
        }else{
            
            let ms;
            let m = moment(value);
            let d;
            
            if(m.isValid()){
                
                d=new Date(m.toDate());
                ms  ={
                ms:moment(value).toISOString()
            }
                this.value=d;
            }else{
                ms=null;
                
            }
            
            
            
            this._onChange(ms);
        }
    };

    registerOnTouched() { }
    writeValue(value: any) {
        if(value  && value.ms){
            let d:Date = new Date(value.ms);
            this.value = d;
             this.onChangeDate(this.value);
        }else{
            this.value = null ;
        }
       
    }

    constructor(public rootService:RootService) { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormTime/aFormTime.component.ts